import { useState, useEffect, useCallback } from "react";
import { useCursor } from "../../context/CursorContext";

export default function CustomCursor() {
  const [pos, setPos] = useState({ x: -100, y: -100 });
  const [visible, setVisible] = useState(false);
  const [isDesktop, setIsDesktop] = useState(false);
  const [suppressed, setSuppressed] = useState(false);
  const { isLightCursor } = useCursor();

  const cursorColor = isLightCursor ? "#eaeaeb" : "#1c1917";

  useEffect(() => {
    const mq = window.matchMedia("(min-width: 1024px)");
    setIsDesktop(mq.matches);
    const handler = (e: MediaQueryListEvent) => setIsDesktop(e.matches);
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, []);

  const onMove = useCallback((e: MouseEvent) => {
    setPos({ x: e.clientX, y: e.clientY });
    setVisible(true);
  }, []);

  const onLeave = useCallback(() => setVisible(false), []);
  const onEnter = useCallback(() => setVisible(true), []);

  const onOver = useCallback((e: MouseEvent) => {
    const target = e.target as Element;
    setSuppressed(!!target.closest("[data-hide-cursor]"));
  }, []);

  useEffect(() => {
    if (!isDesktop) return;
    document.addEventListener("mousemove", onMove);
    document.addEventListener("mouseleave", onLeave);
    document.addEventListener("mouseenter", onEnter);
    document.addEventListener("mouseover", onOver);
    return () => {
      document.removeEventListener("mousemove", onMove);
      document.removeEventListener("mouseleave", onLeave);
      document.removeEventListener("mouseenter", onEnter);
      document.removeEventListener("mouseover", onOver);
    };
  }, [isDesktop, onMove, onLeave, onEnter, onOver]);

  if (!isDesktop) return null;

  return (
    <>
      <style>{`
        @media (min-width: 1024px) {
          * { cursor: none !important; }
        }
      `}</style>
      <div
        aria-hidden="true"
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "8px",
          height: "8px",
          borderRadius: "50%",
          backgroundColor: cursorColor,
          pointerEvents: "none",
          zIndex: 9999,
          transform: `translate(${pos.x - 4}px, ${pos.y - 4}px)`,
          opacity: visible && !suppressed ? 1 : 0,
          transition: "opacity 0.2s ease",
        }}
      />
    </>
  );
}
